import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
	const { pathname, hash } = useLocation();

	useEffect(() => {
		if (hash) {
			const id = hash.replace("#", "");
			setTimeout(() => {
				const element = document.getElementById(id);
				if (element) element.scrollIntoView({ behavior: "smooth", block: "start" });
			}, 80);
			return;
		}
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
	}, [pathname, hash]);

	return null;
};

export default ScrollToTop;
